import { render, staticRenderFns } from "./ViewCompanyType.vue?vue&type=template&id=5b03def1&"
import script from "./ViewCompanyType.vue?vue&type=script&lang=js&"
export * from "./ViewCompanyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports